var _path, _path2, _path3, _path4, _text, _path5, _path6, _path7, _path8, _text2, _path9, _path10, _path11, _path12, _text3, _path13, _path14, _text4, _path15, _path16, _path17, _path18, _text5, _path19, _path20, _text6, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlogharibodevuk = function SvgBlogharibodevuk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "581px",
    height: "301px",
    viewBox: "-0.5 -0.5 581 301",
    content: "<mxfile host=\"Electron\" modified=\"2023-05-07T20:31:33.116Z\" agent=\"5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/20.8.16 Chrome/106.0.5249.199 Electron/21.4.0 Safari/537.36\" etag=\"jGRoiuRvvlDarulfhSIA\" version=\"20.8.16\" type=\"device\"><diagram name=\"Page-1\" id=\"-JdIhzaMDBoA5VTaUZls\">7Vnbbts4EP0aPzawblb8GMtxt0AKFDW23X0yGGkscUOLWoryJV+/Q4myLlQMB+vdNK0TG9acGYrD4ZwjSx45wWb/UZAs+cwjYCN7HO1Hznxk25bj2/ihkEOF3LpOBcSCRjqoAZb0GTQ41mhBI8g7gZJzJmnWBUOephDKDkaE4Ltu2Jqz7qwZifWM4wZYhoSBEfadRjLRq7D9Bv8NaJzUM1uTaeXZkDpYnzhPSMR3Lci5HzmB4FxWR5t9AEwVr65LNW7xgveYmIBUnjNA/s0P9nb59OkQ+c/fPvrfPkyfP1h6e3J5qFcMERZAm1zIhMc8Jey+QWeCF2kE6rRjtJqYB84zBC0E/wIpD3o3SSE5QoncMO2t5lQTvbgWDeW8ECGcWIDOXxIRgzwR5x4rjq0KfANSHHCcAEYk3XbzILpn4mNcU1Y80JV9RZV1klvCCj3T7zkIo/L5E8gwqctaSEZTCI59rcA1T2XAGRflAAf/FyqNWSxIRKHxpTxVG5VLwZ9gaMCaMtbC1+Uf4hHJk+PObkFIilR4II/AvvCcSspT9D1yKfmmFXDHaKwcUu3/jGgrxIRwlZ2dVwvQbYGtp21dATUlybNqtWu6V3nMkDWZcm72sRKYG7LL3RsBVV98ClU+MzSro25UkZez69pjqrA/3W5me9QDag5rEbMnbmXvGkmY6pCkpQY1dvGGqtXx/6UtVksc/tDjS+NPZdx4tTnft53zQ9v6AoLi4tWWlOAFNcA9UwO8t9QA19CAr0hx8JzTMpBxmsoyF2+GL9z3oHp7GBoo5Mb2BsAhzDdBywzDD2tohj44hPkmaJlhyqqz7oJDmO+ZGfdHWwOjrd5ofP1LVUXf1PXmC7vlm1OBJ6p0MVWcMsXVu3PGM29Ijn9K2RWqrVfY1xeR3qOG1tLrjw3p9W9N6a2xi/N4elXenqKeobyTt1Rez1DegPEiWggkwVV8r+L7M4lvqDp7XXb2ReTXdX4w+Z0YZF5ev0G9JxJPxneO47+OxLbvW9bklyFxfqHvTt7kByPv7Tt/2OS/hxtN31DIu+DzVSLfkUQuPNd3p6+TyMC3HGvxy0hkqLJbY354q7khKYlBrP4j1bS8N1ZNyzIZ/X2JQHkbYzB7kMwGkfskNgjcJa9BjD4pDEJ0qWmwt09xQwe6UmGwtU9pg/cnyfjC8/JWM+8SKmGZkfJ6sMPGO6PBsU8lwbmEPke5EyDut1BtSBXDGMly+ngchdQuRI6Xha+QVycfv8SNGC+GWZn+ECdK7woPV+VdwIowefZvALoAp0nPYF2eEatC0/ihtObOKXHrSM4lnga5PW7aJjfdOqZNTvv29Y/i0Wx+nSt9rd84nft/AA==</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f54749-1-c7131f-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(199, 19, 31)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(245, 71, 73)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 100 199 L 173.63 199",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 178.88 199 L 171.88 202.5 L 173.63 199 L 171.88 195.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 10 154 L 100 154 L 100 244 L 10 244 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.59 231.73 C 26.4 215.5 39.28 202.56 55 202.56 C 60.31 202.56 65.52 204.06 70.06 206.89 C 78.49 212.14 83.89 221.55 84.41 231.73 Z M 38.95 182.44 C 38.95 173.53 46.15 166.27 55 166.27 C 63.85 166.27 71.05 173.53 71.05 182.44 C 71.05 191.35 63.85 198.6 55 198.6 C 46.15 198.6 38.95 191.35 38.95 182.44 Z M 71.79 204.11 C 68.96 202.34 65.88 201.06 62.69 200.26 C 69.53 197.26 74.32 190.41 74.32 182.44 C 74.32 171.72 65.65 163 55 163 C 44.35 163 35.68 171.72 35.68 182.44 C 35.68 190.42 40.49 197.28 47.34 200.27 C 32.98 203.88 22.27 217.33 22.27 233.36 C 22.27 234.27 23 235 23.91 235 L 86.09 235 C 86.99 235 87.73 234.27 87.73 233.36 C 87.73 221.45 81.62 210.24 71.79 204.11 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 251,
      marginLeft: 55
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "User")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 263,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "User")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 258 199 L 313.63 199",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 318.88 199 L 311.88 202.5 L 313.63 199 L 311.88 195.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 180 160 L 258 160 L 258 238 L 180 238 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 228.66 199.82 C 229.49 200.58 229.9 201.6 229.9 202.88 C 229.9 204.27 229.4 205.38 228.4 206.21 C 227.4 207.04 226.05 207.46 224.37 207.46 C 223.03 207.46 221.71 207.17 220.41 206.6 L 220.41 204.9 C 221.95 205.41 223.27 205.67 224.37 205.67 C 225.44 205.67 226.27 205.43 226.86 204.94 C 227.44 204.46 227.73 203.77 227.73 202.88 C 227.73 201.16 226.64 200.3 224.47 200.3 C 223.79 200.3 223.12 200.34 222.45 200.41 L 222.45 199.01 L 226.92 194.13 L 220.62 194.13 L 220.62 192.38 L 229.28 192.38 L 229.28 194.07 L 224.9 198.71 C 224.97 198.69 225.04 198.69 225.11 198.69 L 225.32 198.69 C 226.73 198.69 227.84 199.07 228.66 199.82 M 216.3 199.45 C 217.17 200.26 217.6 201.37 217.6 202.79 C 217.6 204.18 217.1 205.31 216.09 206.17 C 215.08 207.03 213.76 207.46 212.11 207.46 C 210.66 207.46 209.31 207.17 208.05 206.6 L 208.05 204.9 C 209.62 205.41 210.97 205.67 212.09 205.67 C 213.17 205.67 213.99 205.42 214.57 204.93 C 215.14 204.44 215.43 203.74 215.43 202.81 C 215.43 201.81 215.16 201.08 214.62 200.62 C 214.08 200.17 213.2 199.94 211.98 199.94 C 211.1 199.94 210 200.01 208.68 200.15 L 208.68 198.75 L 209.09 192.38 L 216.86 192.38 L 216.86 194.13 L 210.88 194.13 L 210.6 198.45 C 211.38 198.31 212.08 198.24 212.7 198.24 C 214.24 198.24 215.44 198.64 216.3 199.45 M 232.29 215.05 C 226.9 216.02 222.17 218.22 219 220.01 C 215.83 218.22 211.1 216.02 205.71 215.05 C 204.19 214.78 196.62 213.2 196.62 208.83 C 196.62 206.8 197.34 205.45 198.74 203.05 C 200.4 200.18 202.48 196.61 202.48 191.46 C 202.48 187.78 201.51 184.25 199.61 180.96 C 199.83 180.69 200.06 180.41 200.29 180.13 C 203.11 181.54 206.04 182.25 209.03 182.25 C 212.67 182.25 216.03 181.29 219 179.4 C 221.97 181.29 225.32 182.25 228.97 182.25 C 231.95 182.25 234.89 181.54 237.71 180.13 C 237.94 180.41 238.17 180.69 238.39 180.96 C 236.49 184.25 235.52 187.78 235.52 191.46 C 235.52 196.61 237.6 200.18 239.26 203.06 C 240.65 205.45 241.38 206.8 241.38 208.83 C 241.38 213.2 233.81 214.78 232.29 215.05 M 237.75 191.46 C 237.75 187.95 238.74 184.58 240.69 181.46 C 240.94 181.05 240.91 180.53 240.61 180.16 C 240.04 179.47 239.45 178.74 238.86 178.02 C 238.53 177.6 237.94 177.48 237.46 177.74 C 234.72 179.26 231.87 180.02 228.97 180.02 C 225.48 180.02 222.42 179.09 219.63 177.15 C 219.25 176.89 218.75 176.89 218.37 177.15 C 215.58 179.09 212.52 180.02 209.03 180.02 C 206.13 180.02 203.27 179.26 200.54 177.74 C 200.06 177.48 199.47 177.6 199.13 178.02 C 198.55 178.74 197.96 179.47 197.39 180.16 C 197.09 180.53 197.06 181.05 197.31 181.46 C 199.26 184.58 200.25 187.95 200.25 191.46 C 200.25 196.01 198.35 199.29 196.81 201.94 C 195.31 204.52 194.39 206.24 194.39 208.83 C 194.39 214.82 202.75 216.78 205.31 217.24 C 210.72 218.21 215.43 220.5 218.44 222.25 C 218.61 222.36 218.81 222.41 219 222.41 C 219.19 222.41 219.39 222.36 219.56 222.25 C 222.57 220.5 227.28 218.21 232.69 217.24 C 235.25 216.78 243.6 214.82 243.6 208.83 C 243.6 206.24 242.69 204.52 241.19 201.94 C 239.65 199.29 237.75 196.01 237.75 191.46 M 233.45 221.48 C 226.63 222.71 220.92 226.37 219 227.71 C 217.08 226.37 211.37 222.71 204.55 221.48 C 191.13 219.07 190.09 211.18 190.09 208.83 C 190.09 204.94 191.62 202.32 193.09 199.78 C 194.5 197.36 195.95 194.85 195.95 191.46 C 195.95 186.1 192.86 182.31 191.33 180.77 C 192.93 178.82 196.99 173.88 198.99 171.3 C 202.02 174.16 205.54 175.72 209.03 175.72 C 212.89 175.72 216.09 174.15 219 170.79 C 221.91 174.15 225.1 175.72 228.97 175.72 C 232.45 175.72 235.98 174.16 239.01 171.3 C 241.01 173.88 245.06 178.82 246.67 180.77 C 245.14 182.31 242.05 186.1 242.05 191.46 C 242.05 194.85 243.5 197.36 244.91 199.78 C 246.38 202.32 247.91 204.94 247.91 208.83 C 247.91 211.18 246.86 219.07 233.45 221.48 M 246.83 198.66 C 245.46 196.29 244.27 194.25 244.27 191.46 C 244.27 185.58 248.85 181.78 248.89 181.74 C 249.12 181.55 249.27 181.28 249.3 180.99 C 249.33 180.69 249.24 180.4 249.05 180.17 C 248.98 180.08 241.69 171.24 240.02 168.95 C 239.82 168.69 239.52 168.52 239.19 168.5 C 238.86 168.47 238.54 168.61 238.31 168.85 C 235.51 171.84 232.19 173.5 228.97 173.5 C 225.41 173.5 222.61 171.91 219.88 168.35 C 219.46 167.8 218.54 167.8 218.12 168.35 C 215.39 171.91 212.59 173.5 209.03 173.5 C 205.81 173.5 202.49 171.84 199.69 168.85 C 199.46 168.61 199.14 168.47 198.81 168.5 C 198.48 168.52 198.17 168.69 197.98 168.95 C 196.31 171.24 189.02 180.08 188.95 180.17 C 188.76 180.4 188.67 180.69 188.7 180.99 C 188.73 181.28 188.87 181.55 189.1 181.74 C 189.15 181.78 193.73 185.58 193.73 191.46 C 193.73 194.25 192.54 196.29 191.17 198.66 C 189.62 201.33 187.87 204.35 187.87 208.83 C 187.87 216.29 193.96 221.84 204.16 223.67 C 211.84 225.05 218.26 229.92 218.32 229.97 C 218.52 230.12 218.76 230.2 219 230.2 C 219.24 230.2 219.48 230.12 219.68 229.97 C 219.74 229.92 226.14 225.05 233.84 223.67 C 244.04 221.84 250.13 216.29 250.13 208.83 C 250.13 204.35 248.38 201.33 246.83 198.66",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 245,
      marginLeft: 219
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Route53")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 219,
    y: 257,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Route53")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 398 199 L 443.63 199",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 448.88 199 L 441.88 202.5 L 443.63 199 L 441.88 195.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 160 L 398 160 L 398 238 L 320 238 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 375.85 212.51 C 375.85 210.67 374.35 209.17 372.51 209.17 C 370.66 209.17 369.16 210.67 369.16 212.51 C 369.16 214.35 370.66 215.85 372.51 215.85 C 374.35 215.85 375.85 214.35 375.85 212.51 Z M 378.08 212.51 C 378.08 215.58 375.58 218.08 372.51 218.08 C 369.44 218.08 366.94 215.58 366.94 212.51 C 366.94 209.44 369.44 206.94 372.51 206.94 C 375.58 206.94 378.08 209.44 378.08 212.51 Z M 348.29 196.43 C 348.29 194.59 346.79 193.09 344.95 193.09 C 343.11 193.09 341.61 194.59 341.61 196.43 C 341.61 198.27 343.11 199.77 344.95 199.77 C 346.79 199.77 348.29 198.27 348.29 196.43 Z M 350.52 196.43 C 350.52 199.5 348.02 202 344.95 202 C 341.88 202 339.38 199.5 339.38 196.43 C 339.38 193.36 341.88 190.86 344.95 190.86 C 348.02 190.86 350.52 193.36 350.52 196.43 Z M 358.7 178.95 C 358.7 180.79 360.2 182.29 362.04 182.29 C 363.89 182.29 365.38 180.79 365.38 178.95 C 365.38 177.11 363.89 175.61 362.04 175.61 C 360.2 175.61 358.7 177.11 358.7 178.95 Z M 356.47 178.95 C 356.47 175.88 358.97 173.38 362.04 173.38 C 365.11 173.38 367.61 175.88 367.61 178.95 C 367.61 182.02 365.11 184.52 362.04 184.52 C 358.97 184.52 356.47 182.02 356.47 178.95 Z M 387.97 199 C 387.97 188.67 382.43 179.11 373.5 173.94 C 371.9 174.26 370.35 174.7 368.42 175.4 L 367.66 173.31 C 368.67 172.94 369.57 172.65 370.44 172.4 C 366.85 170.85 362.95 170.03 359 170.03 C 357.12 170.03 355.27 170.22 353.46 170.58 C 354.77 171.34 355.93 172.11 357.06 172.96 L 355.71 174.74 C 354.12 173.53 352.47 172.51 350.31 171.38 C 339.36 174.82 331.48 184.47 330.23 195.8 C 332.53 195.34 334.73 195.08 337.18 195.02 L 337.23 197.25 C 334.67 197.31 332.47 197.58 330.06 198.11 C 330.05 198.41 330.03 198.71 330.03 199 C 330.03 208.65 334.8 217.54 342.65 222.9 C 341.25 218.74 340.56 214.81 340.56 210.97 C 340.56 208.79 340.94 206.99 341.33 205.09 C 341.43 204.65 341.52 204.2 341.61 203.73 L 343.8 204.16 C 343.7 204.64 343.61 205.1 343.51 205.54 C 343.12 207.41 342.79 209.02 342.79 210.97 C 342.79 215.33 343.74 219.83 345.69 224.72 C 349.83 226.87 354.31 227.97 359 227.97 C 362.07 227.97 365.07 227.48 367.93 226.54 C 369.05 224.32 369.88 222.24 370.58 219.84 L 372.72 220.46 C 372.21 222.21 371.63 223.8 370.93 225.38 C 372.73 224.57 374.43 223.57 376.03 222.41 C 375.65 221.46 375.23 220.53 374.78 219.61 L 376.77 218.62 C 377.16 219.39 377.51 220.18 377.85 220.98 C 384.3 215.46 387.97 207.54 387.97 199 Z M 390.2 199 C 390.2 208.72 385.78 217.72 378.08 223.68 C 376.17 225.16 374.1 226.39 371.91 227.38 C 370.99 227.8 370.04 228.19 369.07 228.52 C 365.86 229.64 362.47 230.2 359 230.2 C 353.87 230.2 348.78 228.92 344.28 226.51 C 334.11 221.07 327.8 210.53 327.8 199 C 327.8 198.24 327.82 197.65 327.87 197.12 C 328.62 184.1 337.56 172.83 350.09 169.1 C 352.94 168.24 355.94 167.8 359 167.8 C 364.36 167.8 369.63 169.18 374.25 171.79 C 384.09 177.3 390.2 187.73 390.2 199 Z M 356.01 182.8 L 354.54 181.12 C 352.04 183.3 350.1 185.62 347.83 189.11 L 349.7 190.33 C 351.85 187.01 353.68 184.84 356.01 182.8 Z M 352.62 197.25 L 351.9 199.35 C 357.01 201.11 361.48 203.92 365.95 208.18 L 367.49 206.56 C 362.78 202.07 358.05 199.11 352.62 197.25 Z M 367.52 184.14 C 371.7 190.52 374.06 197.52 374.52 204.95 L 372.29 205.09 C 371.85 198.05 369.62 191.41 365.66 185.37 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 245,
      marginLeft: 359
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "CloudFront")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 359,
    y: 257,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CloudFront")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 450 160 L 528 160 L 528 238 L 450 238 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 512.28 202.22 L 512.71 199.21 C 516.66 201.57 516.71 202.55 516.71 202.58 C 516.7 202.58 516.03 203.14 512.28 202.22 Z M 510.12 201.62 C 503.3 199.56 493.8 195.2 489.96 193.39 C 489.96 193.37 489.96 193.36 489.96 193.34 C 489.96 191.86 488.76 190.66 487.28 190.66 C 485.81 190.66 484.61 191.86 484.61 193.34 C 484.61 194.82 485.81 196.02 487.28 196.02 C 487.93 196.02 488.52 195.78 488.98 195.39 C 493.51 197.53 502.93 201.82 509.8 203.85 L 507.08 223.03 C 507.07 223.08 507.07 223.13 507.07 223.18 C 507.07 224.87 499.6 227.97 487.39 227.97 C 475.05 227.97 467.49 224.87 467.49 223.18 C 467.49 223.13 467.49 223.08 467.48 223.03 L 461.81 181.57 C 466.72 184.95 477.29 186.74 487.39 186.74 C 497.48 186.74 508.03 184.96 512.96 181.59 Z M 461.21 177.25 C 461.29 175.78 469.71 170.03 487.39 170.03 C 505.07 170.03 513.5 175.78 513.58 177.25 L 513.58 177.75 C 512.61 181.04 501.69 184.51 487.39 184.51 C 473.07 184.51 462.15 181.02 461.21 177.73 Z M 515.81 177.27 C 515.81 173.41 504.74 167.8 487.39 167.8 C 470.05 167.8 458.98 173.41 458.98 177.27 L 459.08 178.11 L 465.27 223.27 C 465.41 228.32 478.88 230.2 487.39 230.2 C 497.94 230.2 509.15 227.77 509.3 223.27 L 511.97 204.44 C 513.45 204.8 514.68 204.98 515.66 204.98 C 516.98 204.98 517.87 204.66 518.41 204.01 C 518.85 203.49 519.02 202.85 518.89 202.16 C 518.61 200.62 516.77 198.96 513.05 196.83 L 515.69 178.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 245,
      marginLeft: 489
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "S3")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 489,
    y: 257,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "S3")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 450 79 L 359 79 L 359 153.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 359 158.88 L 355.5 151.88 L 359 153.63 L 362.5 151.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 450 40 L 528 40 L 528 118 L 450 118 Z",
    fill: "url(#mx-gradient-f54749-1-c7131f-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 484.2 78.2 C 484.48 78.47 484.6 78.86 484.52 79.24 L 483.38 84.48 L 488.42 81.39 C 488.77 81.17 489.23 81.17 489.58 81.39 L 494.59 84.48 L 493.48 79.22 C 493.4 78.85 493.52 78.46 493.79 78.2 L 498.29 73.79 L 492.42 72.94 C 492.06 72.89 491.74 72.66 491.58 72.33 L 488.99 67.02 L 486.34 72.34 C 486.18 72.67 485.86 72.89 485.5 72.95 L 479.65 73.8 Z M 480.64 86.56 L 482.21 79.37 L 476.47 73.83 C 476.16 73.53 476.05 73.09 476.18 72.69 C 476.31 72.28 476.66 71.99 477.08 71.93 L 484.6 70.83 L 488 64.01 C 488.19 63.63 488.55 63.37 489 63.39 C 489.43 63.39 489.81 63.64 490 64.02 L 493.33 70.82 L 500.84 71.91 C 501.26 71.97 501.61 72.26 501.74 72.66 C 501.87 73.07 501.76 73.51 501.46 73.81 L 495.79 79.36 L 497.31 86.56 C 497.4 87 497.22 87.44 496.86 87.7 C 496.49 87.96 496.01 87.97 495.63 87.74 L 489 83.65 L 482.31 87.75 C 482.13 87.86 481.93 87.91 481.73 87.91 C 481.5 87.91 481.28 87.85 481.09 87.71 C 480.72 87.45 480.55 87 480.64 86.56 Z M 460.03 57.85 L 517.97 57.85 L 517.97 52.26 L 460.03 52.26 Z M 520.2 51.14 L 520.2 106.86 C 520.2 107.47 519.7 107.97 519.09 107.97 L 512.4 107.97 L 512.4 105.74 L 517.97 105.74 L 517.97 60.08 L 460.03 60.08 L 460.03 105.74 L 502.37 105.74 L 502.37 107.97 L 458.91 107.97 C 458.3 107.97 457.8 107.47 457.8 106.86 L 457.8 51.14 C 457.8 50.53 458.3 50.03 458.91 50.03 L 519.09 50.03 C 519.7 50.03 520.2 50.53 520.2 51.14 Z M 471.17 100.17 L 477.86 100.17 L 477.86 97.94 L 471.17 97.94 Z M 482.31 100.17 L 497.91 100.17 L 497.91 97.94 L 482.31 97.94 Z M 471.17 94.6 L 477.86 94.6 L 477.86 92.37 L 471.17 92.37 Z M 482.31 94.6 L 506.83 94.6 L 506.83 92.37 L 482.31 92.37 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 125,
      marginLeft: 489
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "ACM")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 489,
    y: 137,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ACM")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 10 L 570 10 L 570 290 L 130 290 Z",
    fill: "none",
    stroke: "#232f3e",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 136.09 17.18 C 136.01 17.18 135.93 17.19 135.85 17.19 C 135.5 17.19 135.15 17.23 134.81 17.32 C 134.53 17.39 134.25 17.49 133.98 17.62 C 133.9 17.65 133.84 17.7 133.79 17.76 C 133.75 17.83 133.74 17.91 133.74 17.99 L 133.74 18.32 C 133.74 18.46 133.78 18.53 133.88 18.53 L 133.99 18.53 L 134.22 18.44 C 134.45 18.35 134.69 18.27 134.94 18.21 C 135.17 18.16 135.41 18.13 135.65 18.13 C 136.04 18.09 136.43 18.2 136.74 18.44 C 136.97 18.74 137.09 19.12 137.05 19.5 L 137.05 19.99 C 136.78 19.93 136.54 19.88 136.29 19.84 C 136.05 19.81 135.81 19.79 135.57 19.79 C 134.98 19.76 134.4 19.94 133.94 20.31 C 133.54 20.65 133.32 21.15 133.34 21.68 C 133.31 22.15 133.49 22.62 133.82 22.96 C 134.18 23.29 134.66 23.46 135.15 23.44 C 135.91 23.45 136.63 23.11 137.11 22.51 C 137.18 22.66 137.24 22.79 137.31 22.91 C 137.38 23.02 137.46 23.12 137.55 23.21 C 137.6 23.27 137.67 23.31 137.75 23.31 C 137.81 23.31 137.87 23.29 137.92 23.25 L 138.34 22.97 C 138.41 22.93 138.46 22.86 138.47 22.77 C 138.47 22.72 138.45 22.67 138.42 22.62 C 138.34 22.47 138.26 22.31 138.21 22.14 C 138.15 21.95 138.12 21.75 138.13 21.55 L 138.14 19.37 C 138.2 18.77 138 18.18 137.59 17.74 C 137.17 17.39 136.64 17.19 136.09 17.18 Z M 149.89 17.19 C 149.78 17.19 149.68 17.19 149.57 17.2 C 149.29 17.2 149 17.24 148.73 17.31 C 148.47 17.38 148.23 17.5 148.01 17.66 C 147.82 17.81 147.66 17.99 147.54 18.21 C 147.42 18.43 147.35 18.67 147.36 18.92 C 147.36 19.27 147.48 19.61 147.69 19.89 C 147.97 20.22 148.34 20.46 148.76 20.56 L 149.72 20.87 C 149.97 20.93 150.2 21.05 150.39 21.22 C 150.51 21.35 150.58 21.51 150.57 21.69 C 150.58 21.94 150.45 22.18 150.23 22.31 C 149.93 22.48 149.6 22.56 149.26 22.54 C 148.99 22.54 148.72 22.51 148.46 22.45 C 148.22 22.4 147.98 22.32 147.75 22.22 L 147.59 22.15 C 147.54 22.14 147.5 22.14 147.46 22.15 C 147.36 22.15 147.31 22.22 147.31 22.36 L 147.31 22.69 C 147.31 22.76 147.32 22.82 147.35 22.89 C 147.4 22.97 147.47 23.03 147.56 23.07 C 147.8 23.19 148.06 23.28 148.32 23.34 C 148.66 23.41 149 23.45 149.35 23.45 L 149.33 23.46 C 149.66 23.45 149.98 23.4 150.29 23.3 C 150.55 23.22 150.8 23.09 151.01 22.92 C 151.21 22.77 151.38 22.57 151.49 22.34 C 151.61 22.1 151.67 21.83 151.66 21.56 C 151.67 21.23 151.56 20.9 151.36 20.63 C 151.09 20.32 150.73 20.09 150.33 19.99 L 149.39 19.69 C 149.13 19.61 148.88 19.49 148.67 19.32 C 148.54 19.2 148.47 19.03 148.47 18.85 C 148.46 18.61 148.58 18.38 148.79 18.25 C 149.06 18.11 149.36 18.05 149.67 18.06 C 150.11 18.06 150.55 18.14 150.96 18.32 C 151.04 18.37 151.12 18.4 151.21 18.41 C 151.31 18.41 151.36 18.34 151.36 18.19 L 151.36 17.88 C 151.37 17.8 151.35 17.72 151.31 17.66 C 151.25 17.59 151.18 17.54 151.11 17.49 L 150.83 17.38 L 150.45 17.27 L 150.01 17.2 C 149.97 17.2 149.93 17.19 149.89 17.19 Z M 146.02 17.36 C 145.94 17.35 145.86 17.38 145.79 17.42 C 145.72 17.5 145.68 17.59 145.66 17.69 L 144.51 22.14 L 143.47 17.71 C 143.45 17.61 143.41 17.52 143.34 17.44 C 143.26 17.39 143.17 17.37 143.07 17.38 L 142.54 17.38 C 142.44 17.37 142.35 17.39 142.27 17.44 C 142.2 17.51 142.15 17.61 142.14 17.71 L 141.09 22.14 L 139.97 17.7 C 139.95 17.6 139.91 17.51 139.84 17.44 C 139.76 17.39 139.67 17.36 139.58 17.37 L 138.92 17.37 C 138.81 17.37 138.76 17.43 138.76 17.54 C 138.77 17.63 138.79 17.72 138.82 17.81 L 140.38 22.95 C 140.4 23.05 140.45 23.14 140.52 23.21 C 140.6 23.26 140.69 23.29 140.78 23.28 L 141.36 23.26 C 141.46 23.27 141.55 23.25 141.63 23.19 C 141.7 23.12 141.74 23.03 141.76 22.93 L 142.79 18.64 L 143.82 22.93 C 143.83 23.03 143.88 23.12 143.95 23.19 C 144.03 23.25 144.12 23.27 144.21 23.26 L 144.78 23.26 C 144.88 23.27 144.97 23.25 145.04 23.2 C 145.11 23.13 145.16 23.03 145.18 22.94 L 146.79 17.79 C 146.84 17.72 146.84 17.63 146.84 17.63 C 146.84 17.59 146.84 17.56 146.84 17.52 C 146.84 17.48 146.82 17.43 146.79 17.4 C 146.76 17.37 146.72 17.35 146.67 17.36 L 146.05 17.36 C 146.04 17.36 146.03 17.36 146.02 17.36 Z M 135.65 20.62 C 135.7 20.62 135.75 20.62 135.8 20.62 L 136.43 20.62 C 136.64 20.64 136.85 20.67 137.06 20.71 L 137.06 21.01 C 137.07 21.21 137.05 21.4 137 21.59 C 136.96 21.75 136.88 21.9 136.77 22.01 C 136.61 22.21 136.39 22.36 136.14 22.44 C 135.91 22.52 135.67 22.56 135.43 22.56 C 135.18 22.6 134.93 22.53 134.73 22.37 C 134.55 22.18 134.46 21.92 134.49 21.66 C 134.47 21.36 134.59 21.08 134.81 20.89 C 135.06 20.72 135.35 20.62 135.65 20.62 Z M 151.04 24.72 C 150.34 24.73 149.51 24.89 148.88 25.33 C 148.69 25.46 148.72 25.63 148.94 25.63 C 149.64 25.54 151.21 25.35 151.5 25.71 C 151.78 26.06 151.19 27.54 150.94 28.21 C 150.86 28.41 151.03 28.49 151.21 28.34 C 152.39 27.36 152.72 25.3 152.46 25 C 152.32 24.85 151.74 24.71 151.04 24.72 Z M 132.65 25.1 C 132.5 25.12 132.42 25.3 132.58 25.44 C 135.29 27.89 138.82 29.23 142.48 29.21 C 145.37 29.22 148.2 28.36 150.59 26.74 C 150.95 26.47 150.63 26.07 150.26 26.23 C 147.87 27.24 145.3 27.76 142.71 27.77 C 139.23 27.78 135.82 26.87 132.81 25.14 C 132.75 25.11 132.69 25.1 132.65 25.1 Z M 130 10 L 155 10 L 155 35 L 130 35 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 408,
      height: 1,
      paddingTop: 17,
      marginLeft: 162
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 162,
    y: 29,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlogharibodevuk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blog.haribodev.uk.5bd4f51635093cda29e2ed4a000a9c0e.svg";